import React from "react";
import styled from 'styled-components';

import { LabeledData } from "./LabeledData";
import { LabeledDataRow } from "./LabeledDataRow";

const StyledServalBuildBlock = styled.section`
	background: ${(props) => props.theme.colors.neutral1};
	color: ${(props) => props.theme.colors.neutral10};
	scroll-snap-align: start;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.fourth}) {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
`;

const ContentContainer = styled.div`
	box-sizing: border-box;
	padding: 1.75rem 1.5rem;
	max-width: 32rem;
	margin: 0 auto;

	:first-child {
		margin-top: 0;
	}

	${LabeledDataRow} {
		margin-top: 2rem;
	}
		
	@media only screen and (min-width: ${(props) => props.theme.breakpoints.fourth}) {
		margin: 0;
	}
`;

const Title = styled.h3`
	${(props) => props.theme.typography.headingL};
	margin-top: 0;
`;

const Build = styled.div``;

export class ServalBuildBlock extends React.Component {

	render() {
		return (
			<StyledServalBuildBlock>
				<ContentContainer>
					<Title>Digital/high-end build</Title>
					<Build>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="ESC"
								data="Sequre Blueson A1"
								supplemental="This super-cheap ESC actually delivered excellent performance in Chris Rosser's ESC test. The only drawback is its slightly higher weight."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Flight controller"
								data="HDZero Halo Flight Controller"
								supplemental="Great pad layout, integrated Gemini ELRS receiver, good value for money."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Camera"
								data="HDZero Nano 90"
								supplemental="The camera for the HDZero system."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Video transmitter"
								data="HDZero Race VTX"
								supplemental="Ultra low latency and 90fps makes HDZero the best for racing."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="VTX antenna"
								data="Foxeer Lollipop Micro"
								supplemental="Great price, reliable."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Motors"
								data="T-Motor F60 2207 1950KV"
								supplemental="An excellent motor overall. Believe me: 1950KV is more than enough."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Propellers"
								data="Gemfan Yuki 5129-3"
								supplemental="Low pitch propellers for better control."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Batteries"
								data="6S batteries 1200-1400mAh"
								supplemental="I'd recommend Tattu / Boslipo for performance or Ovonic for value."
							/>
						</LabeledDataRow>
					</Build>
				</ContentContainer>
				<ContentContainer>
					<Title>Analog/budget build</Title>
					<Build>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="ESC"
								data="Sequre Blueson A1"
								supplemental="This super-cheap ESC actually delivered excellent performance in Chris Rosser's ESC test. The only drawback is its slightly higher weight."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Flight controller"
								data="HDZero Halo Flight Controller"
								supplemental="Great pad layout, integrated Gemini ELRS receiver, good value for money."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Camera"
								data="Foxeer Predator Nano"
								supplemental="The best analog camera for racing."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Video transmitter"
								data="TBS Unify Pro32 Nano VTX"
								supplemental="Tiny weight, with enough power for a race."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="VTX antenna"
								data="Foxeer Lollipop Micro"
								supplemental="Great price, reliable."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Motors"
								data="Flyfish Sword 2207 1950KV"
								supplemental="Unbeatable price, okay durability."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Propellers"
								data="Gemfan Yuki 5129-3"
								supplemental="Low pitch propellers for better control."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Batteries"
								data="6S batteries 1200-1400mAh"
								supplemental="I'd recommend Tattu / Boslipo for performance or Ovonic for value."
							/>
						</LabeledDataRow>
					</Build>
				</ContentContainer>
			</StyledServalBuildBlock>
		);
	}
}